import { render, staticRenderFns } from "./ModalOrderAddress.vue?vue&type=template&id=f812bc0c&"
import script from "./ModalOrderAddress.vue?vue&type=script&lang=js&"
export * from "./ModalOrderAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports